import React from 'react';
import { Box, Typography, Paper, Skeleton } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import { formatMoney } from '../../../utils/currency';

const MostImpactfulIngredientsChart = ({ data = [], loading }) => {
  const top10 = [...data]
    .sort((a, b) => b.totalCost - a.totalCost)
    .slice(0, 10);

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        Insumos con más impacto en recetas
      </Typography>
      <Box sx={{ width: '100%', height: 320 }}>
        {loading ? (
          <Skeleton variant="rectangular" width="100%" height={320} />
        ) : top10.length > 0 ? (
          <ResponsiveContainer>
            <BarChart
              data={top10}
              layout="vertical"
              margin={{ top: 10, right: 30, left: 0, bottom: 5 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis
                type="category"
                dataKey="name"
                width={160}
                tickFormatter={(name) =>
                  name.length > 30 ? `${name.slice(0, 30)}...` : name
                }
              />
              <Tooltip formatter={(value) => `${formatMoney(value)}`} />
              <Bar dataKey="totalCost" fill="#42a5f5" name="Costo total" />
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2" color="textSecondary">
              No hay datos disponibles.
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default MostImpactfulIngredientsChart;
